import BackgroundImage from "gatsby-background-image"
import React from "react"
import Heading from "../Global/Heading"

export default function Contact({ photo }) {
  return (
    <BackgroundImage className="section py-3 mb-3" fluid={photo}>
      <Heading title="contact us" />
      <div className="col-10 col-sm-8 mx-auto py-3">
        <form
          action="https://formspree.io/f/xdoyzlbw"
          className="form-group"
          method="POST"
        >
          <div className="form-group ">
            <input
              className="form-control"
              type="text"
              name="name"
              id="name"
              placeholder="Your Name"
            />
          </div>
          <div className="form-group  ">
            <input
              className="form-control"
              type="text"
              name="email"
              id="email"
              placeholder="Your email"
            />
          </div>
          <div className="form-group">
            <input
              className="form-control mb-3"
              type="text"
              name="phone"
              id="phone"
              placeholder="Your phone"
            />
          </div>
          <div className="form-group mt-3">
            <textarea
              className="form-control align-right"
              type="text"
              name="description"
              id="description"
              placeholder="Your message"
            />
          </div>
          <button type="submit" className="btn btn-outline-info btn-block ">
            Submit
          </button>
        </form>
      </div>
    </BackgroundImage>
  )
}
